import Button from "component/ui/Button";
import React from "react";
import { useParams } from "react-router-dom";
import { purchaseDetail } from "../../../helper/constant";
import PageHeading from "component/ui/PageHeading";
import PageContainer from "component/ui/PageContainer";

export default function PurchaseDetail() {
  const { id } = useParams();

  const purchaseDetailItem = purchaseDetail.find(
    (item) => item.id === Number(id)
  );

  if (!purchaseDetailItem) {
    return <p className="text-center mt-10">Purchase data not found</p>;
  }
  return (
    <PageContainer>
      <PageHeading title={"Booking Details"} />

      <div className="space-y-6">
        {/* User Card */}
        <div className="bg-white rounded-xl shadow md:p-6 p-3">
          <h2 className="text-xl font-semibold mb-1 capitalize">
            {purchaseDetailItem.user.name}
          </h2>
          <p className="text-gray-500 md:text-base text-sm">
            Booked on {purchaseDetailItem.dateOfpurchaseDetail}
          </p>
          <p className="text-blue-600 mt-2 md:text-base text-sm flex items-center gap-1">
            📍 {purchaseDetailItem.location}
          </p>
        </div>

        {/* Booking Info */}
        <div className="bg-white rounded-xl shadow md:p-6 p-3">
          <h3 className="font-semibold mb-4">Booking Information</h3>
          <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-sm">
            <div>
              <p className="text-gray-500">Sport</p>
              <p className="font-medium">{purchaseDetailItem.sportName}</p>
            </div>
            <div>
              <p className="text-gray-500">Booked For</p>
              <p className="font-medium">
                {purchaseDetailItem.dateOfpurchaseDetail}
              </p>
            </div>
            <div>
              <p className="text-gray-500">Reference ID</p>
              <p className="text-blue-600 font-medium">
                {purchaseDetailItem.refrenceId}
              </p>
            </div>
            <div className="flex md:flex-row flex-col justify-between md:items-center items-start">
              <div>
                <p className="text-gray-500">Status</p>
                <span className="inline-block px-3 py-1 text-xs bg-green-100 text-green-700 rounded-full">
                  Confirmed
                </span>
              </div>

              <Button className="md:block hidden">Download Invoice</Button>
            </div>
          </div>
          <Button className="block md:hidden mt-5">Download Invoice</Button>
        </div>

        {/* Slots */}
        <div className="bg-white rounded-xl shadow md:p-6 p-3">
          <h3 className="font-semibold mb-2">Booked Slots</h3>
          <p className="text-sm text-red-500 mb-4">
            Reschedule / Cancellation window is closed
          </p>
          <div className="flex flex-wrap gap-3 md:justify-start justify-center w-full">
            {purchaseDetailItem.slots.map((slot, slotIndex) => (
              <div
                key={slotIndex}
                className="text-sm text-center md:p-3 p-2 rounded-lg bg-gray-100 text-gray-500"
              >
                {slot}
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Payment Summary */}
      <div className="space-y-6 mt-6">
        <div className="bg-white rounded-xl shadow md:p-6 p-3 w-full">
          <h3 className="font-semibold mb-4">Payment Summary</h3>
          <div className="flex justify-between items-center">
            <span className="text-gray-500 md:text-base text-sm">
              Amount Paid
            </span>
            <span className="text-xl font-semibold text-green-600">
              ₹{purchaseDetailItem.amountPaid}
            </span>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}
